import { useRef as u, useState as o, useCallback as m } from "react";
import c from "../useUnmount/useUnmount.js";
function l(t) {
  const e = u(0), [n, a] = o(t), r = m((s) => {
    cancelAnimationFrame(e.current), e.current = requestAnimationFrame(() => {
      a(s);
    });
  }, []);
  return c(() => {
    cancelAnimationFrame(e.current);
  }), [n, r];
}
export {
  l as default
};
//# sourceMappingURL=useRequestAnimationFrameState.js.map
